import React, { useEffect, useState } from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import { useForm, useFieldArray } from "react-hook-form";
import { formSections } from "./Form";
// import { getValueAsType } from "framer-motion";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import API from "../../../services/axiosInstance";
import { da } from "react-day-picker/locale";
import { FormLoader, useFormLoader } from "../../common_modules/loader";

// import useSubmitPrevent from "../../utils/SubmitPrevent";
import usePreventMultiClick from "../../utils/SubmitPrevent";

import Permission from "../../security/permission";
import { AUTH_CODE } from "../../security/authCodes";

// Trim only the beginning and end of strings, including values in field arrays.
// Keeps the internal whitespace of HTML, CSS, and JavaScript ad tags unchanged.
const trimAllStrings = (value) => {
    if (typeof value === "string") {
        return value.trim();
    }

    if (Array.isArray(value)) {
        return value.map(trimAllStrings);
    }

    if (
        value !== null &&
        typeof value === "object" &&
        Object.getPrototypeOf(value) === Object.prototype
    ) {
        return Object.fromEntries(
            Object.entries(value).map(([key, nestedValue]) => [
                key,
                trimAllStrings(nestedValue)
            ])
        );
    }

    return value;
};

const AdPlacement = () => {
    const { id: accId, guid: accGuid, placementId } = useParams();
    const [adData, setAdData] = useState("");
    const [isFormLoaded, setIsFormLoaded] = useState(false);
    const [publisherName, setPublisherName] = useState("");
    const [buttonErrors, setButtonErrors] = useState({});
    const [multiButtonErrors, setMultiButtonErrors] = useState({});
    // For Loading 
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook loader

    const isEdit = !!placementId;
    console.log(isEdit);
    
    // const  location = useParams();        
    // const  accId = location?.id;
    // const  accGuid = location?.guid;
    const navigate = useNavigate();
    const location = useLocation();
    // const submittingRef = useSubmitPrevent();
    const { btnClicked, setBtnClicked } = usePreventMultiClick();
    // for defaultvalues
    const getDefaultValues = () => {
        const defaults = {};

        formSections.forEach(section => {
            if (section.isArray) return;
            section.fields.forEach(field => {
                if (field.defaultValue !== undefined) {
                    defaults[field.name] = field.defaultValue;
                }
            });
        });

        console.log(defaults);
        // console.log(watch("useAsCallback"));
        return defaults;
    };

    // Hide the hideen fields
    const getAllFields = () => {
        let allFields = [];

        formSections.forEach(section => {
            if (section.isArray) return;
            section.fields?.forEach(field => {
                allFields.push(field);
            });
        });

        return allFields;
    };

    const fetchAdPlacement = async () => {
        startLoading();
        try {
            const res = await API.get(`/publisher/adplacement/${placementId}/${accId}`);
            let data = res?.data.data;
            setPublisherName(res?.data?.name);
            const defaults = getDefaultValues();
            const normalizedData = { ...data };
            formSections.forEach(section => {
                section.fields?.forEach(field => {
                    if (field.type === "select" && field.defaultValue !== undefined &&
                        (normalizedData[field.name] === "" || normalizedData[field.name] === null || normalizedData[field.name] === undefined)) {
                        normalizedData[field.name] = field.defaultValue;
                    }
                })
            })
            setAdData(data);

            // parse JSON fields
            const mediation = data?.mediationDetails
                ? JSON.parse(data.mediationDetails).map(item => ({
                    wTagType: item.tagType || "ADX",
                    timeDelay: item.timeDelay || "",
                    wheadTag: item.head || "",
                    wbodyTag: item.body || "",
                }))
                : [];
            const multitag = data.multitagSetting
                ? JSON.parse(data.multitagSetting).map(item => ({
                    mHeadTag: item.head,
                    mBodyTag: item.body,

                    mDivgptID: item.divGpt,

                    mSizeMappingVariable: item.sizeMappingVariable,

                    ...(["VignetteAds", "RewardedAds", "AnchorAds"].includes(data.interscrollerFeature) && {
                        mAdUnitSlotId: item.sizeMappingVariable,
                    }),

                    mMainAdUnitSize: item.mainAdUnit,
                    mRefreshAdUnit: item.refreshAdUnit,

                    mConvertedHeadTag: item.customHeadTag,
                    mConvertedBodyTag: item.customBodyTag,
                })) :
                [];
            // parse JSON fields
            // data.mediationDetails = data.mediationDetails?.length
            // ? JSON.parse(data.mediationDetails) 
            // : [
            //     {
            //         wTagType: "ADX",
            //         timeDelay: "",
            //         wheadTag: "",
            //         wbodyTag: "",
            //     }
            // ];

            // data.multitagSetting = data.multitagSetting?.length
            // ? JSON.parse(data.multitagSetting) 
            // : [
            //     {
            //         mHeadTag: "",
            //         mBodyTag: "",
            //         mDivgptID: "",
            //         mSizeMappingVariable: "",
            //         mMainAdUnitSize: "",
            //         mRefreshAdUnit: "",
            //         mConvertedHeadTag: "",
            //         mConvertedBodyTag: "",
            //     }
            // ];

            // Set form values
            reset({
                // ...getDefaultValues(), // fallback defaults
                ...defaults,
                // ...data,
                ...normalizedData,
                mediationDetails: mediation,
                multitagSetting: multitag
            });
            setIsFormLoaded(true);
            //   setTimeout(() => {
            //   console.log("watch desiredFormat", watch("desiredFormat"));
            //   console.log("watch desRefresh", watch("desRefresh"));
            // }, 1000);
            // IMPORTANT: sync field arrays
            replace(mediation.length ? mediation : [{
                wTagType: "ADX",
                timeDelay: "",
                wheadTag: "",
                wbodyTag: "",
            }]);

            multiReplace(multitag.length ? multitag : [{
                mHeadTag: "",
                mBodyTag: "",
                mDivgptID: "",
                mSizeMappingVariable: "",
                mMainAdUnitSize: "",
                mRefreshAdUnit: "",
                mConvertedHeadTag: "",
                mConvertedBodyTag: "",
            }]);

        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            stopLoading();
        }
    };

    // apply customize button functionality
    const handleAction = (action) => {
        if (action === "applyCustomTag") {
            const values = getValues();
            const formatType = values.interscrollerFeature;
            const adUnit = values.adUnitId;
            const isHB = values.enableHeaderBidding;
            let headTag = (values.headTag).trim() || "";
            let bodyTag = (values.bodyTag).trim() || "";
            const gptId = "DIV_GPT_ID"; // DIV_GPT_ID
            const slotVar = "SLOT_VARIABLE"; // SLOT_VARIABLE

            // Validation
            if (!values.gptId) {
                alert("Please fill Div GPT ID");
                return;
            } else if ((formatType === "VignetteAds" || formatType === "RewardedAds" || formatType === "AnchorAds") && !values.adUnitId) {
                alert("Please fill Ad Unit Slot ID");
                return;
            }
            // rewarded/anchor/vignett condition 
            if (formatType === "RewardedAds" || formatType === "VignetteAds" || formatType === "AnchorAds") {
                const position = values.position;
                let gptFormat = "REWARDED";
                if (formatType === "VignetteAds") {
                    gptFormat = "INTERSTITIAL";
                }
                if (formatType === "AnchorAds") {
                    if (!values.position) {
                        alert("Please select position");
                        return;
                    }
                    gptFormat = position === "top" ? "TOP_ANCHOR" : "BOTTOM_ANCHOR"
                }
                // 🔥 CASE 1: Rewarded + Header Bidding
                if (isHB === "1" && formatType !== "AnchorAds") {
                    const headTag = `<script data-tr-hb=${gptId} async src="//micro.rubiconproject.com/prebid/dynamic/23058.js"></script>
<script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
<script>
window.googletag = window.googletag || {cmd: []};
googletag.cmd.push(function() {
window.${slotVar} = googletag.defineOutOfPageSlot('${adUnit}', googletag.enums.OutOfPageFormat.${gptFormat});
if (window.${slotVar}) {
window.${slotVar}.addService(googletag.pubads());
}
googletag.pubads().collapseEmptyDivs();
googletag.pubads().disableInitialLoad();
googletag.pubads().enableSingleRequest();
googletag.enableServices();
demandManagerRequest([window.${slotVar}]);
});
</script>`
                    const bodyTag = `<div id='${gptId}'>
<script>
googletag.cmd.push(function() { googletag.display(window.${slotVar}); });
</script>
</div>`
                    setValue("convertedHeadTag", headTag);
                    setValue("convertedBodyTag", bodyTag);
                    return;
                }
                const headTag = `<script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
<script>
window.googletag = window.googletag || {cmd: []};
googletag.cmd.push(function() {
window.${slotVar} = googletag.defineOutOfPageSlot('${adUnit}', googletag.enums.OutOfPageFormat.${gptFormat});
if (window.${slotVar}) {
window.${slotVar}.addService(googletag.pubads());
}
googletag.pubads().collapseEmptyDivs();
googletag.enableServices();
});
</script>`;

                const bodyTag = `<div id='${gptId}'>
<script>
googletag.cmd.push(function() { googletag.display(window.${slotVar}); })
</script>
</div>`

                setValue("convertedHeadTag", headTag);
                setValue("convertedBodyTag", bodyTag);
                return;
            }
            // 1. Replace ALL GPT div ids FIRST in Head Tag
            if (headTag.includes(values?.gptId)) {
                headTag = headTag.replaceAll((values?.gptId), "DIV_GPT_ID");
            }
            // headTag = headTag.replace(
            //   /div-gpt-ad-\d+-\d+/g,
            //   gptId
            // );
            // 1. Replace ALL GPT div ids FIRST in Body Tag
            if (bodyTag.includes(values?.gptId)) {
                bodyTag = bodyTag.replaceAll((values?.gptId), "DIV_GPT_ID");
            }
            // bodyTag = bodyTag.replace(
            //   /div-gpt-ad-\d+-\d+/g,
            //   gptId
            // );

            // 2. Replace slot variable
            const sizeMappingVariable = (values.sizeMappingVariable || "").trim();
            // Existing variable assignment before defineSlot?
            const hasVariableBeforeDefineSlot =
                /(\w+)\s*=\s*googletag\.defineSlot\(/.test(headTag);
            if (sizeMappingVariable) {
                const escaped = sizeMappingVariable.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                const regex = new RegExp(`\\b${escaped}\\b`, "g");

                // Case 1:
                // Size Mapping Variable is provided AND found.
                if (headTag.includes(sizeMappingVariable)) {
                    headTag = headTag.replace(regex, `window.${slotVar}`);
                }

                // Case 2:
                // Size Mapping Variable provided BUT not found.
                // else if (hasVariableBeforeDefineSlot) {

                //     headTag = headTag.replace(
                //         /(\w+)\s*=\s*googletag\.defineSlot\(/,
                //         `$1 = window.${slotVar} = googletag.defineSlot(`
                //     );
                // }

                // Case 3:
                // No variable before defineSlot().
                // else {
                //     headTag = headTag.replace(
                //         /googletag\.defineSlot\(/,
                //         `window.${slotVar} = googletag.defineSlot(`
                //     );
                // }
            }

            // Size Mapping Variable is blank.
            else {
                // Case 4:
                // Existing variable assignment found.
                if (hasVariableBeforeDefineSlot) {
                    headTag = headTag.replace(
                        /(\w+)\s*=\s*googletag\.defineSlot\(/,
                        `$1 = window.${slotVar} = googletag.defineSlot(`
                    );
                }

                // Case 5:
                // No variable assignment exists.
                else {
                    headTag = headTag.replace(
                        /googletag\.defineSlot\(/,
                        `window.${slotVar} = googletag.defineSlot(`
                    );
                }
            }

            // headTag = headTag.replace(
            //   /\bresponsiveAdSlot1\b/g,
            //   `window.${slotVar}`
            // );

            // 3. Add googletag.cmd fallback (only once)
            if (!headTag.includes("googletag.cmd = googletag.cmd || []")) {
                headTag = headTag.replace(
                    /googletag\.cmd\.push/g,
                    `googletag.cmd = googletag.cmd || [];\n  googletag.cmd.push`
                );
            }

            // 4. Add data-tr with UPDATED GPT ID (important: AFTER replace)

            headTag = headTag.replace(
                /<script(.*?)>/g,
                `<script data-tr='${gptId}'$1>`
            );

            // headTag = headTag.replace(
            //     /<script([^>]*securepubads\.g\.doubleclick\.net\/tag\/js\/gpt\.js[^>]*)>/,
            //     `<script data-tr='${gptId}'$1>`
            // );

            // 5. Header Bidding Changes
            if (isHB === "1") {

                // Add HB script before GPT script (only once)
                if (!headTag.includes("dynamic/23058.js")) {
                    headTag =
                        `<script data-tr-hb='${gptId}' async src="//micro.rubiconproject.com/prebid/dynamic/23058.js"></script>\n` +
                        headTag;
                }

                // Add HB methods before enableServices() (only once)
                if (!headTag.includes("demandManagerRequest")) {
                    headTag = headTag.replace(
                        /googletag\.enableServices\(\);/,
                        `googletag.pubads().disableInitialLoad();
googletag.pubads().enableSingleRequest();
googletag.enableServices();
demandManagerRequest([window.${slotVar}]);`
                    );
                }
            }

            //Final set
            setValue("convertedHeadTag", headTag);
            setValue("convertedBodyTag", bodyTag);

            console.log("FINAL TAG:", headTag);
            console.log("FINAL TAG:", bodyTag);
        }
    };

    // apply multitag customize tag button
    const handleActionMulti = (action, index) => {
        if (action === "applyCustomTagMulti") {
            const values = getValues();
            const current = values.multitagSetting?.[index];
            if (!current) return;

            let headTag = current.mHeadTag || "";
            let bodyTag = current.mBodyTag || "";
            const gptId = current.mDivgptID; // DIV_GPT_ID
            const slotVar = current.mSizeMappingVariable; // SLOT_VARIABLE
            const adUnit = current.mAdUnitSlotId;
            const formatType = values.interscrollerFeature;
            const isHB = values.enableHeaderBidding;
            const gptIdMulti = "DIV_GPT_ID"; // DIV_GPT_ID
            const slotVarMulti = "SLOT_VARIABLE"; // SLOT_VARIABLE

            // ✅ Validation
            // if (!gptId || !adUnit) {
            //   alert("Please fill Div GPT ID and Ad Unit Slot ID");
            //   return;
            // }
            // Validation
            if (!gptId) {
                alert("Please fill Div GPT ID");
                return;
            } else if ((formatType === "VignetteAds" || formatType === "RewardedAds" || formatType === "AnchorAds") && !adUnit) {
                alert("Please fill Ad Unit Slot ID");
                return;
            }
            // rewarded/anchor/vignett condition
            if (formatType === "RewardedAds" || formatType === "VignetteAds" || formatType === "AnchorAds") {
                const position = values.position;
                let gptFormat = "REWARDED";

                if (formatType === "VignetteAds") gptFormat = "INTERSTITIAL";

                if (formatType === "AnchorAds") {
                    if (!values.position) {
                        alert("Please select position");
                        return;
                    }
                    gptFormat = position === "top" ? "TOP_ANCHOR" : "BOTTOM_ANCHOR";
                }
                // CASE 1: Rewarded + Header Bidding
                if (isHB === "1" && formatType !== "AnchorAds") {
                    const headTag = `<script data-tr-hb=${gptIdMulti} async src="//micro.rubiconproject.com/prebid/dynamic/23058.js"></script>
            <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
            <script>
            window.googletag = window.googletag || {cmd: []};
            googletag.cmd.push(function() {
            window.${slotVarMulti} = googletag.defineOutOfPageSlot('${adUnit}', googletag.enums.OutOfPageFormat.${gptFormat});
            if (window.${slotVarMulti}) {
            window.${slotVarMulti}.addService(googletag.pubads());
            }
            googletag.pubads().collapseEmptyDivs();
            googletag.pubads().disableInitialLoad();
            googletag.pubads().enableSingleRequest();
            googletag.enableServices();
            demandManagerRequest([window.${slotVarMulti}]);
            });
            </script>`
                    const bodyTag = `<div id=${gptIdMulti}>
                        <script>
                        googletag.cmd.push(function() { googletag.display(window.${slotVarMulti}); });
                        </script>
                        </div>`
                    setValue(`multitagSetting.${index}.mConvertedHeadTag`, headTag);
                    setValue(`multitagSetting.${index}.mConvertedBodyTag`, bodyTag);
                    return;
                }
                const headTag = `<script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
        <script>
        window.googletag = window.googletag || {cmd: []};
        googletag.cmd.push(function() {
        window.${slotVarMulti} = googletag.defineOutOfPageSlot('${adUnit}', googletag.enums.OutOfPageFormat.${gptFormat});
        if (window.${slotVarMulti}) {
        window.${slotVarMulti}.addService(googletag.pubads());
        }
        googletag.pubads().collapseEmptyDivs();
        googletag.enableServices();
        });
        </script>`;
                const bodyTag = `<div id=${gptIdMulti}>
<script>
googletag.cmd.push(function() { googletag.display(window.${slotVarMulti}); });
</script>
</div>`
                setValue(`multitagSetting.${index}.mConvertedHeadTag`, headTag);
                setValue(`multitagSetting.${index}.mConvertedBodyTag`, bodyTag);
                return;
            }

            // 1. Replace ALL GPT div ids FIRST
            // headTag = headTag.replace(
            //   /div-gpt-ad-\d+-\d+/g,
            //   gptIdMulti
            // );
            if (headTag.includes(gptId)) {
                headTag = headTag.replaceAll((gptId), "DIV_GPT_ID");
            }
            if (bodyTag.includes(gptId)) {
                bodyTag = bodyTag.replaceAll((gptId), "DIV_GPT_ID");
            }

            // 1. Replace ALL GPT div ids FIRST
            // bodyTag = bodyTag.replace(
            //   /div-gpt-ad-\d+-\d+/g,
            //   gptIdMulti
            // );

            // 2. Replace slot variable

            // headTag = headTag.replace(
            //   /\bresponsiveAdSlot1\b/g,
            //   `window.${slotVar}`
            // );

            // 2. Replace slot variable
            const sizeMappingVariable = (slotVar || "").trim();
            // Existing variable assignment before defineSlot?
            const hasVariableBeforeDefineSlot =
                /(\w+)\s*=\s*googletag\.defineSlot\(/.test(headTag);

            if (sizeMappingVariable) {
                const escaped = sizeMappingVariable.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                const regex = new RegExp(`\\b${escaped}\\b`, "g");

                // Case 1:
                // Size Mapping Variable is provided AND found.
                if (headTag.includes(sizeMappingVariable)) {
                    headTag = headTag.replace(regex, `window.${slotVarMulti}`);
                }

                // Case 2:
                // Size Mapping Variable provided BUT not found.
                // else if (hasVariableBeforeDefineSlot) {
                //     headTag = headTag.replace(
                //         /(\w+)\s*=\s*googletag\.defineSlot\(/,
                //         `$1 = window.${slotVarMulti} = googletag.defineSlot(`
                //     );
                // }

                // Case 3:
                // No variable before defineSlot().
                // else {
                //     headTag = headTag.replace(
                //         /googletag\.defineSlot\(/,
                //         `window.${slotVarMulti} = googletag.defineSlot(`
                //     );
                // }
            }

            // Size Mapping Variable is blank.
            else {
                // Case 4:
                // Existing variable assignment found.
                if (hasVariableBeforeDefineSlot) {
                    headTag = headTag.replace(
                        /(\w+)\s*=\s*googletag\.defineSlot\(/,
                        `$1 = window.${slotVarMulti} = googletag.defineSlot(`
                    );
                }

                // Case 5:
                // No variable assignment exists.
                else {
                    headTag = headTag.replace(
                        /googletag\.defineSlot\(/,
                        `window.${slotVarMulti} = googletag.defineSlot(`
                    );
                }
            }

            // 3. Add googletag.cmd fallback (only once)
            if (!headTag.includes("googletag.cmd = googletag.cmd || []")) {
                headTag = headTag.replace(
                    /googletag\.cmd\.push/g,
                    `googletag.cmd = googletag.cmd || [];\n  googletag.cmd.push`
                );
            }

            // 4. Add data-tr with UPDATED GPT ID (important: AFTER replace)
            headTag = headTag.replace(
                /<script(.*?)>/g,
                `<script data-tr='${gptIdMulti}'$1>`
                // /<script([^>]*securepubads\.g\.doubleclick\.net\/tag\/js\/gpt\.js[^>]*)>/,
                //     `<script data-tr='${gptIdMulti}'$1>`
            );

            // 5. Header Bidding Changes
            if (isHB === "1") {

                // Add HB script before GPT script (only once)
                if (!headTag.includes("dynamic/23058.js")) {
                    headTag =
                        `<script data-tr-hb='${gptIdMulti}' async src="//micro.rubiconproject.com/prebid/dynamic/23058.js"></script>\n` +
                        headTag;
                }

                // Add HB methods before enableServices() (only once)
                if (!headTag.includes("demandManagerRequest")) {
                    headTag = headTag.replace(
                        /googletag\.enableServices\(\);/,
                        `googletag.pubads().disableInitialLoad();
googletag.pubads().enableSingleRequest();
googletag.enableServices();
demandManagerRequest([window.${slotVarMulti}]);`
                    );
                }
            }
            //Final set
            setValue(`multitagSetting.${index}.mConvertedHeadTag`, headTag);
            setValue(`multitagSetting.${index}.mConvertedBodyTag`, bodyTag);

            console.log("FINAL TAG:", headTag);
            console.log("FINAL TAG:", bodyTag);
        }
    };

    const { register, handleSubmit, watch, getValues, setValue, reset, resetField, control, formState: { errors } } = useForm({
        defaultValues: {
            ...getDefaultValues(),
            mediationDetails: [
                {
                    wTagType: "ADX",
                    timeDelay: "",
                    wheadTag: "",
                    wbodyTag: "",
                }
            ],
            multitagSetting: [
                {
                    mHeadTag: "",
                    mBodyTag: "",
                    mDivgptID: "",
                    mSizeMappingVariable: "",
                    mMainAdUnitSize: "",
                    mRefreshAdUnit: "",
                    mConvertedHeadTag: "",
                    mConvertedBodyTag: "",
                }
            ]
        }
    });
    console.log("useAsCallback =", watch("useAsCallback"));

    // for waterfall
    const { fields, append, remove, replace } = useFieldArray({
        control,
        name: "mediationDetails"
    })

    // for multitag
    const { fields: multiFields, append: multiAppend, remove: multiRemove, replace: multiReplace } = useFieldArray({
        control,
        name: "multitagSetting"
    })

    const formValues = watch();
    console.log("Selected:", watch("desiredFormat"));
    // const generationType = watch("generationType");

    // check section is visible or not
    // const isSectionVisible = (title, data) => {
    // const section = formSections.find(s => s.title === title);

    // return section
    //     ? checkVisibility(section.visibleWhen, data)
    //     : true;
    // };

    // check filed is visible or not
    //     const getVisibleFormData = (data) => {
    //     const visibleData = {};

    //     getAllFields().forEach(field => {
    //         if (field.type === "button") return;
    //         const isVisible = checkVisibility(field.visibleWhen, data);

    //         if (isVisible && data[field.name] !== undefined) {
    //             visibleData[field.name] = data[field.name];
    //         }
    //     });

    //     return visibleData;
    // };

    const getVisibleFormData = (data) => {
        const visibleData = {};
        const visibleSections = {};

        formSections.forEach(section => {

            const sectionVisible = checkVisibility(section.visibleWhen, data);

            // Store section visibility
            if (section.title) {
                visibleSections[section.title] = sectionVisible;
            }

            // Skip hidden sections
            if (!sectionVisible) return;

            section.fields?.forEach(field => {

                if (field.type === "button") return;

                const fieldVisible = checkVisibility(field.visibleWhen, data);

                // Match the extra Adsense visibility rule used by the JSX renderer.
                const hiddenForAdsense =
                    section.title === "ADX Setting" &&
                    data.tagType === "Adsense" &&
                    field.adsenseVisible !== true;

                if (fieldVisible && !hiddenForAdsense && data[field.name] !== undefined) {
                    visibleData[field.name] = data[field.name];
                }
            });
        });

        return {
            visibleData,
            visibleSections
        };
    };

    const onSubmit = async (data) => {
        if (btnClicked) return;
        setBtnClicked(true);
        startLoading();

        try {
            // Clean the submitted form values once. This includes nested field arrays.
            const trimmedData = trimAllStrings(data);
            const { visibleData, visibleSections } = getVisibleFormData(trimmedData);
            const isRefreshEnabled = String(trimmedData.refresh) === "1";
            const formatType = ["VignetteAds", "RewardedAds", "AnchorAds"].includes(
                trimmedData.interscrollerFeature
            );

            // Header-bidding validation is applicable only to visible ADX settings.
            if (visibleSections["ADX Setting"] && trimmedData.tagType === "ADX") {
                const hasDemandManagerRequest =
                    trimmedData.convertedHeadTag?.includes("demandManagerRequest") ?? false;

                if (
                    (trimmedData.enableHeaderBidding === "1" && !hasDemandManagerRequest) ||
                    (trimmedData.enableHeaderBidding !== "1" && hasDemandManagerRequest)
                ) {
                    setButtonErrors({
                        applyCustomTag: "Please Apply Customized Head Tag."
                    });
                    return;
                }
            }
            setButtonErrors({});

            // Check only the multi-tag section if it is visible.
            const tagErrors = {};
            if (visibleSections["Multi Tag Settings"]) {
                (trimmedData.multitagSetting ?? []).forEach((item, index) => {
                    const hasTag = Boolean(item.mHeadTag || item.mBodyTag);
                    if (!hasTag) return;

                    const hasDemandManagerRequest =
                        item.mConvertedHeadTag?.includes("demandManagerRequest") ?? false;

                    if (
                        (trimmedData.enableHeaderBidding === "1" && !hasDemandManagerRequest) ||
                        (trimmedData.enableHeaderBidding !== "1" && hasDemandManagerRequest)
                    ) {
                        tagErrors[index] = "Please Apply Customized Head Tag.";
                    }
                });
            }

            if (Object.keys(tagErrors).length > 0) {
                setMultiButtonErrors(tagErrors);
                return;
            }
            setMultiButtonErrors({});

            // Arrays must be trimmed before JSON.stringify, not after.
            // Keep the API's existing JSON-string format for these two properties.
            const payload = trimAllStrings({
                ...visibleData,

                mediationDetails: JSON.stringify(
                    (trimmedData.mediationDetails ?? []).map(item => ({
                        tagType: item.wTagType,
                        head: item.wheadTag,
                        body: item.wbodyTag,
                        timeDelay: item.timeDelay,
                    }))
                ),

                ...(visibleSections["Multi Tag Settings"] && {
                    multitagSetting: JSON.stringify(
                        (trimmedData.multitagSetting ?? []).map(item => ({
                            head: item.mHeadTag,
                            body: item.mBodyTag,
                            divGpt: item.mDivgptID,

                            // Preserve the existing special-format mapping.
                            sizeMappingVariable: formatType
                                ? item.mAdUnitSlotId
                                : item.mSizeMappingVariable,

                            ...(isRefreshEnabled && {
                                mainAdUnit: item.mMainAdUnitSize,
                                refreshAdUnit: item.mRefreshAdUnit,
                            }),

                            customHeadTag: item.mConvertedHeadTag,
                            customBodyTag: item.mConvertedBodyTag,
                        }))
                    ),
                }),

                id: isEdit ? placementId : "",
                accountId: accId,
                guid: adData?.guid || "",
                accountGuid: accGuid,
                autogeneratedId: adData?.autogeneratedId || 0,
            });

            console.log("Cleaned Ad Placement Payload:", payload);

            const url = isEdit
                ? "/publisher/adplacement/update"
                : "/publisher/adplacement/save";

            const response = isEdit
                ? await API.put(url, payload)
                : await API.post(url, payload);

            if (response?.data?.status === "Success") {
                alert(response?.data?.message || "Success");
                if (!isEdit) reset();
                navigate(`/publisher/adplacement-list/${accId}/${accGuid}`);
            } else {
                alert(response?.data?.message || "Failed");
            }
        } catch (error) {
            console.error("API ERROR:", error);
            alert(error?.response?.data?.message || "Something went wrong!");
        } finally {
            setBtnClicked(false);
            stopLoading();
        }
    };

    // const checkVisibility = (conditions) => {
    //     if (!conditions) return true;
    //     return conditions.every(cond => {
    //         const value = formValues[cond.field]
    //         if (cond.notIn) {
    //             return !cond.notIn.includes(value);
    //         }
    //         if (Array.isArray(cond.value)) {
    //             return cond.value.includes(value);
    //         }

    //         return value == cond.value;
    //     });
    // };
    const normalize = (val) => {
        if (val === undefined || val === null) return "";
        return String(val).trim();
    };

    // const checkVisibility = (conditions) => {
    const checkVisibility = (conditions, sourceValues = formValues) => {
        if (!conditions) return true;

        return conditions.every(({ field, value, notIn }) => {
            const current = normalize(sourceValues[field]);
            if (notIn) {
                return !notIn.map(normalize).includes(current);
            }

            if (Array.isArray(value)) {
                return value.map(normalize).includes(current);
            }

            return current === normalize(value);
        });
    };

    const getPublisherName = async () => {
        try {
            // only for getting publisherName
            const res = await API.get(`/publisher/adplacement/${0}/${accId}`);
            let data = res?.data.data;
            setPublisherName(res?.data?.name);
        } catch (error) {

        }
    }

    useEffect(() => {
        if (isEdit) {
            fetchAdPlacement();
        } else {
            getPublisherName();
        }
    }, [placementId, reset]);

    // useEffect(() => {
    //     // if (!isFormLoaded) return;
    //   const allFields = getAllFields();

    //   allFields.forEach(field => {
    //     const isVisible = checkVisibility(field.visibleWhen, formValues);

    //     // if (!isVisible && formValues[field.name] !== undefined) {
    //     //   setValue(field.name);
    //     // }
    //     if (!isVisible) {
    //             resetField(field.name, "");
    //             // setValue(field.name, "");
    //     }
    //   });
    // // }, [formValues, isFormLoaded]);

    // }, [formValues]);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="breadCrumb gradient-bg">
                    <Link to={'/dashboard'}><span>Home</span></Link>
                    <Permission code={AUTH_CODE.accounts.publisherListing}>
                        <Link to={'/active-publisher'}><span>Publisher</span></Link>
                    </Permission>
                    <span>{publisherName}</span>
                    <Link to={`/publisher/adplacement-list/${accId}/${accGuid}`}><span>Manage Adplacement</span></Link>
                    <span>{location.pathname.includes("edit") ? "Update" : "Create"}</span>
                    {/* <span>{accId}</span> */}

                </div>
                {formSections.map((section, sIndex) => {
                    // Section-level visibility check
                    if (!checkVisibility(section.visibleWhen, formValues)) {
                        return null;
                    }
                    return (
                        <Card className="mb-4" key={sIndex}>

                            <Card.Header className="fw-bold text-primary">
                                {section.title === "ADX Setting" ? formValues.tagType === "Adsense" ? "Adsense Setting" : "Adx Setting" : section.title}
                            </Card.Header>

                            <Card.Body>
                                {
                                    section.title === "Waterfall Settings" ? (
                                        <>
                                            {
                                                fields.map((field, index) => {
                                                    const rowValues = formValues?.mediationDetails?.[index] || {};
                                                    return (
                                                        <div key={field.id} className="mb-4 border p-3 rounded" style={{ background: "#f9f9f9" }}>
                                                            <div className="d-flex justify-content-between">
                                                                <h6>Setting # {index + 1}</h6>
                                                                {/* DELETE BUTTON */}
                                                                {fields.length > 1 && (
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        style={{ borderRadius: '0' }}
                                                                        onClick={() => remove(index)}
                                                                    >
                                                                        Delete
                                                                    </Button>
                                                                )}
                                                            </div>
                                                            {/*LOOP FIELDS INSIDE EACH ROW */}
                                                            {
                                                                section.fields.map((field, fIndex) => {
                                                                    // Check visibility (use rowValues for per-row condition)
                                                                    if (!checkVisibility(field.visibleWhen, rowValues)) return null;
                                                                    return (
                                                                        <Row className="mb-3" key={fIndex}>
                                                                            <Col md={3}>
                                                                                <Form.Label>{field.label}</Form.Label>
                                                                            </Col>
                                                                            <Col md={5}>
                                                                                {/* TEXT */}
                                                                                {(field.type === "text") && (
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        {...register(`mediationDetails.${index}.${field.name}`)}
                                                                                    />
                                                                                )}

                                                                                {/* SELECT */}
                                                                                {field.type === "select" && (
                                                                                    <Form.Select
                                                                                        {...register(`mediationDetails.${index}.${field.name}`)}
                                                                                    >
                                                                                        {/* <option value="">Select</option> */}
                                                                                        {field.options?.map((opt, i) => (
                                                                                            <option key={i} value={opt.value}>
                                                                                                {opt.label}
                                                                                            </option>
                                                                                        ))}
                                                                                    </Form.Select>
                                                                                )}
                                                                                {/* TEXTAREA */}
                                                                                {field.type === "textarea" && (
                                                                                    <Form.Control
                                                                                        as="textarea"
                                                                                        rows={4}
                                                                                        {...register(`mediationDetails.${index}.${field.name}`)}
                                                                                    />
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                            {/* ADD BUTTON */}
                                            <Button variant="success" style={{ width: '150px', borderRadius: '0' }}
                                                onClick={() =>
                                                    append({
                                                        type: "ADX",
                                                        timeDelay: "",
                                                        wheadTag: "",
                                                        wbodyTag: ""
                                                    })
                                                }
                                            >
                                                + Add More
                                            </Button>
                                        </>
                                    ) : section.title === "Multi Tag Settings" ? (
                                        <>
                                            {
                                                multiFields.map((item, index) => {
                                                    const rowValues = formValues?.multitagSetting?.[index] || {};
                                                    return (
                                                        <div key={item.id} className="mb-4 border p-3 rounded" style={{ background: "#f2f2f2" }}>
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <h6>Multi Tag # {index + 1}</h6>
                                                                {/* DELETE */}
                                                                {multiFields.length > 1 && (
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        onClick={() => multiRemove(index)}
                                                                    >
                                                                        Delete
                                                                    </Button>
                                                                )}
                                                            </div>
                                                            {
                                                                section.fields.map((field, fIndex) => {
                                                                    if (!checkVisibility(field.visibleWhen, formValues)) return null;
                                                                    return (
                                                                        <Row className="mb-3" key={fIndex}>
                                                                            <Col md={3}>
                                                                                <Form.Label>{field.type !== "button" ? field.label : ""}</Form.Label>
                                                                            </Col>
                                                                            <Col md={5}>
                                                                                {/* TEXT */}
                                                                                {field.type === "text" && (
                                                                                    <Form.Control {...register(`multitagSetting.${index}.${field.name}`, typeof field.validation === "function" ? field.validation(formValues, index) : field.validation)} />
                                                                                )}
                                                                                {errors.multitagSetting?.[index]?.[field.name] && (
                                                                                    <small className="text-danger">
                                                                                        {errors.multitagSetting[index][field.name].message}
                                                                                    </small>
                                                                                )}
                                                                                {/* TEXTAREA */}
                                                                                {field.type === "textarea" && (
                                                                                    <Form.Control as="textarea" rows={4} {...register(`multitagSetting.${index}.${field.name}`)} />
                                                                                )}
                                                                                {/* BUTTON */}
                                                                                {field.type === "button" && (
                                                                                    <>
                                                                                        <button
                                                                                            type="button"
                                                                                            className={`btn btn-${field.variant || "primary"}`}
                                                                                            onClick={() => handleActionMulti(field.action, index)}
                                                                                        >
                                                                                            {field.label}
                                                                                        </button>
                                                                                        {
                                                                                            multiButtonErrors[index] && (
                                                                                                <div className="text-danger mt-2">
                                                                                                    {multiButtonErrors[index]}
                                                                                                </div>
                                                                                            )
                                                                                        }
                                                                                    </>
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    )
                                                                })
                                                            }
                                                            {/* Head Tag */}
                                                            {/* <Row className="mb-3">
                                                    <Col md={3}><Form.Label>Head Tag</Form.Label></Col>
                                                    <Col md={5}>
                                                    <Form.Control as="textarea" rows={4} {...register(`multiTag.${index}.mHeadTag`)} />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={3}><Form.Label>Body Tag</Form.Label></Col>
                                                    <Col md={5}>
                                                    <Form.Control as="textarea" rows={4} {...register(`multiTag.${index}.mBodyTag`)} />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={3}><Form.Label>Div GPT ID</Form.Label></Col>
                                                    <Col md={5}>
                                                    <Form.Control {...register(`multiTag.${index}.mDivgptID`)} />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={3}><Form.Label>Size Mapping Variable</Form.Label></Col>
                                                    <Col md={5}>
                                                    <Form.Control {...register(`multiTag.${index}.mSizeMappingVariable`)} />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={3}><Form.Label>Main Ad Unit</Form.Label></Col>
                                                    <Col md={5}>
                                                    <Form.Control {...register(`multiTag.${index}.mMainAdUnitSize`)} />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={3}><Form.Label>Refresh Ad Unit</Form.Label></Col>
                                                    <Col md={5}>
                                                    <Form.Control {...register(`multiTag.${index}.mRefreshAdUnit`)} />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={3}><Form.Label>Customized Head Tag</Form.Label></Col>
                                                    <Col md={5}>
                                                    <Form.Control as="textarea" rows={4} {...register(`multiTag.${index}.mConvertedHeadTag`)} />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={3}><Form.Label>Customized Body Tag</Form.Label></Col>
                                                    <Col md={5}>
                                                    <Form.Control as="textarea" rows={4} {...register(`multiTag.${index}.mConvertedBodyTag`)} />
                                                    </Col>
                                                </Row>
                                                <button
                                                    type="button"
                                                    className="btn btn-warning mb-2"
                                                    onClick={() => handleActionMulti("applyCustomTagMulti", index)}
                                                >
                                                    Customized Tag
                                                </button>*/}
                                                        </div>
                                                    )
                                                })
                                            }
                                            {/* ADD MORE */}
                                            <Button
                                                variant="success"
                                                style={{ width: '150px', borderRadius: '0' }}
                                                onClick={() =>
                                                    multiAppend({
                                                        mHeadTag: "",
                                                        mBodyTag: "",
                                                        mDivgptID: "",
                                                        mSizeMappingVariable: "",
                                                        mMainAdUnitSize: "",
                                                        mRefreshAdUnit: "",
                                                        mConvertedHeadTag: "",
                                                        mConvertedBodyTag: ""
                                                    })
                                                }
                                            >
                                                + Add More
                                            </Button>
                                        </>
                                    ) :

                                        (section.fields.map((field, fIndex) => {
                                            // const checkVisibility = (conditions) => {
                                            //     if(!conditions) return true;
                                            //     return conditions.every(cond => {
                                            //         const value = formValues[cond.field]
                                            //         if (cond.notIn) {
                                            //         return !cond.notIn.includes(value);
                                            //         }
                                            //         if(Array.isArray(cond.value)) {
                                            //             return cond.value.includes(value);
                                            //         }

                                            //         return value == cond.value;
                                            //     });
                                            // };
                                            // 🔹 Field visibility check
                                            if (!checkVisibility(field.visibleWhen, formValues)) {
                                                return null;
                                            }
                                            // Adx setting visibility
                                            if (section.title === "ADX Setting" && formValues.tagType === "Adsense" && field.adsenseVisible !== true) {
                                                return null;
                                            }
                                            return (
                                                <Row className="mb-3" key={fIndex}>
                                                    {/* LABEL */}
                                                    <Col md={3}>
                                                        <Form.Label>{field.type != "button" ? field.label : ''}</Form.Label>
                                                    </Col>
                                                    <Col md={5}>
                                                        {/* TEXT / DATE / NUMBER */}
                                                        {
                                                            (field.type === "text" || field.type === "datetime-local" || field.type === "number") && (
                                                                <Form.Control type={field.type} {...register(field.name, typeof field.validation === "function" ? field.validation(formValues) : field.validation)} />
                                                            )
                                                        }
                                                        {/* SELECT */}
                                                        {
                                                            field.type === "select" && (() => {
                                                                // 🔹 Filter options based on visibleWhen
                                                                let filteredOptions = field.options?.filter(opt =>
                                                                    checkVisibility(opt.visibleWhen)
                                                                );
                                                                // Hide "Both" option on edit
                                                                if (placementId && field.name === "deviceType") {
                                                                    filteredOptions = filteredOptions.filter(
                                                                        opt => opt.value !== "UNKNOWN"
                                                                    );
                                                                }
                                                                // Auto-select first visible option if current value is invalid
                                                                if (field.name === "adCloseBtn") {
                                                                    const currentValue = watch(field.name);
                                                                    if (!filteredOptions.some(opt => opt.value === currentValue)) {
                                                                        setValue(field.name, filteredOptions[0]?.value || "");
                                                                    }
                                                                }
                                                                // 🔹 Check if field already has empty value option
                                                                const hasEmptyOption = filteredOptions?.some(
                                                                    opt => opt.value === ""
                                                                );
                                                                return (
                                                                    <Form.Select {...register(field.name, typeof field.validation === "function" ? field.validation(formValues) : field.validation)} defaultValue={field.defaultValue}>
                                                                        {/* Show Select only if no empty option exists */}
                                                                        {/* {!hasEmptyOption && (
                                                                 <option value="">Select</option>
                                                                )} */}
                                                                        {
                                                                            filteredOptions.map((opt, i) => (
                                                                                <option key={i} value={opt.value}>
                                                                                    {opt.label}
                                                                                </option>
                                                                            ))
                                                                        }
                                                                    </Form.Select>
                                                                )
                                                            })()
                                                        }
                                                        {/* TEXTAREA */}
                                                        {
                                                            field.type === "textarea" && (
                                                                // <Form.Control as="textarea" rows={4} {...register(field.name, field.validation)} />
                                                                <Form.Control as="textarea" rows={4}{...register(
                                                                    field.name,
                                                                    typeof field.validation === "function"
                                                                        ? field.validation(formValues)
                                                                        : field.validation
                                                                )}
                                                                />
                                                            )
                                                        }
                                                        {/* Button */}
                                                        {
                                                            field.type === "button" && (
                                                                <>
                                                                    <button type="button" className={`btn btn-${field.variant || "primary"}`}
                                                                        onClick={() => {
                                                                            if (field.action === "applyCustomTag") {
                                                                                handleAction(field.action);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {field.label}
                                                                    </button>
                                                                    {buttonErrors[field.action] && (
                                                                        <div className="text-danger mt-2">
                                                                            {buttonErrors[field.action]}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )

                                                        }
                                                        {/* HELPER TEXT */}
                                                        {
                                                            field.helperText && (
                                                                <small className="text-muted">
                                                                    {field.helperText}
                                                                </small>
                                                            )
                                                        }
                                                        {/* ERROR */}
                                                        {
                                                            errors[field.name] && (
                                                                <small className="text-danger">
                                                                    {errors[field.name].message}
                                                                </small>
                                                            )
                                                        }
                                                    </Col>

                                                </Row>
                                            )

                                        }))
                                }

                            </Card.Body>

                        </Card>
                    )
                })}

                <Button type="submit" disabled = {btnClicked} className="btn btn-primary submitBtn"> {isEdit ? "Update" : "Submit"} </Button>

                <Button variant="secondary" className="ms-3 submitBtn" size="lg"><Link to={`/publisher/adplacement-list/${accId}/${accGuid}`} style={{ color: "#fff", textDecoration: "none" }}>Cancel</Link></Button>

            </Form>
        </FormLoader>
    );
};

export default AdPlacement;